import { useTranslation } from "@msuite/ui/localization";
import type {
	IncomingInvoiceCheckGroup as CheckGroup,
	IncomingInvoiceCheckKey,
} from "@msuite/utils/incoming-invoices";
import type { IncomingInvoiceCheckList } from "@msuite/utils/types";
import { INCOMING_INVOICE_CHECK_GROUP_LABEL } from "@/components/incoming-invoices";
import { IncomingInvoiceCheckItem } from "./incoming-invoice-check-item";

/** Props Interface */
interface IncomingInvoiceCheckGroupProps {
	group: CheckGroup;
	checkKeys: IncomingInvoiceCheckKey[];
	checks: IncomingInvoiceCheckList;
	currency: string;
}

export function IncomingInvoiceCheckGroup({
	group,
	checkKeys,
	checks,
	currency,
}: IncomingInvoiceCheckGroupProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<section
			className="v-stack gap-2 -mx-4"
			data-cy={`incoming-invoice-check-group-${group}`}
		>
			<div className="px-4">
				<h3 className="label">{t(INCOMING_INVOICE_CHECK_GROUP_LABEL[group])}</h3>
			</div>
			<ul className="v-stack gap-0 divide-y-[0.5px]">
				{checkKeys.map((checkKey) => (
					<IncomingInvoiceCheckItem
						key={checkKey}
						checkKey={checkKey}
						check={checks.find((check) => check.checkKey === checkKey) ?? null}
						currency={currency}
					/>
				))}
			</ul>
		</section>
	);
}
